
import TalentSignupPage from './TalentSignup'

export default class SignupWithoutReferral extends TalentSignupPage
{
    static path = '/signup/talent';

   	/**
     * [Constructor]
     *
     * @param {Object} props
     * @returns {FormPage}
     */
    constructor(props)
    {
		super(props);

		this.state = {
			...this.state,
			isDisabled: false,
			model: {},
		};
	}
}